var path = 'components/material-icon-select.tpl.html';
var html = "\n<div class=\"tb-material-icon-select\" layout=\"row\">\n    <md-icon class=\"material-icons\" ng-click=\"openIconDialog($event)\">{{icon}}</md-icon>\n    <md-input-container flex>\n        <label translate>icon.icon</label>\n        <input ng-mousedown=\"openIconDialog($event)\" ng-model=\"icon\">\n    </md-input-container>\n</div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/components/material-icon-select.tpl.html
// module id = 1410
// module chunks = 1